import script from "./ShareDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareDocument.vue?vue&type=script&setup=true&lang=js"

import "./ShareDocument.vue?vue&type=style&index=0&id=21dfbabc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21dfbabc"]])

export default __exports__